import * as types from '../types'

export default function (payload) {
  return {
    type: types.RENEW_ACCESS_TOKEN,
    payload,
  }
}
